export function pricingSolutionsSlider() {
    let sliderNav = $(".pricing-solutions-nav button");
    let slider = $(".pricing-solutions-slider");
    slider.slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        dots: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    dots: false,
                    arrows: false,
                    fade: true
                }
            }
        ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        sliderNav.removeClass("active");
        sliderNav.parent().eq(nextSlide).find("button").addClass("active");
    });

    sliderNav.on("click", function (e) {
        e.preventDefault();
        let $this = $(this)
        let index = $this.parent().index();
        slider.slick('slickGoTo', index);
        sliderNav.removeClass("active");
        $this.addClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/pricingSolutionsSlider.js